import { CalendarEvent } from 'mini-calendar-event-types';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';

/**
 * Determines the height of freebusy bar in day view
 */
const getFreeBusyBarHeight = (item: CalendarEvent, pixelsPerMinute: number): string => {
    const eventDurationMin =
        item.durationInMs(true /** forCompleteExpansion */) / TimeConstants.MillisecondsIn1Min; // Duration in minutes
    if (eventDurationMin < TimeConstants.MinutesInOneHour / 2) {
        return eventDurationMin * pixelsPerMinute + 'px !important';
    }
    return '100%';
};

export default getFreeBusyBarHeight;
